<template>
  <rpm-input
    :type="question.field_type.label == 'date' ? 'date':'datetime-local'"
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
    class="w-full"
  ></rpm-input>
</template>

<script>

export default {
  name: "DateAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
};
</script>
